import React, {useRef, useEffect, useMemo, useState} from 'react';
import Grid from '@mui/material/Grid';

import {isEqual, isObject, isArray} from 'lodash';
import {isEmptyObj} from 'ultra/helpers/utils';

import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

import {useFormStore} from '../../../Stores/form';

import './index.scss'

export default function JSONEditor(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [hideExample, setHideExample] = useState(true)
    const [showExample, setShowExample] = useState(false)

    const componentRef = useRef(null);
  
    const valueRef = useRef(null);
    const setValueRef = data => {
        valueRef.current = data;
    };

    const [ignoreControlCheck, setIgnoreControlCheck] = useState(false);

    const className = useMemo(() => {
        let result = "JSONField";
        result += isDisabled ? ' disabled' : ''
        result += (!ignoreControlCheck && showErrorText) ? ' error' : ''
        return result;
    }, [isDisabled, showErrorText, ignoreControlCheck])

    const hasInteractionRef = useRef(null);
    const setHasInteraction = data => {
        hasInteractionRef.current = data;
    };

    const handleClickOutside = (e) => {
        const clickOutside = componentRef.current && !componentRef.current.contains(e.target);

        if (!hasInteractionRef.current) {
            if (!clickOutside) setHasInteraction(true);
        }
        else if (clickOutside) {
            setIgnoreControlCheck(false);
            onBlur({target: {value: valueRef.current}});
        }
        else {
            setIgnoreControlCheck(true);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
      if (field.example) setShowExample(true);
      if (field.example && isArray(value) && value.length > 0) setShowExample(false)
      if (field.example && isObject(value) && !isEmptyObj(value)) setShowExample(false)
    }, [])

    const [value, setValue] = useState(field?.options?.isArray ? [] : {})
    useEffect(() => {
        let newValue;
        if (field?.options?.isArray && (!content[field.id] || isEmptyObj(content[field.id]))) {
          newValue = [];
        } else {
          newValue = content[field.id] || {};
        }

        // if (!isEqual(value, newValue))
          setValue(newValue);

        setValueRef(newValue);
    }, [content[field.id]])

    const [isHidden] = useState(field?.options?.hidden)
    if (isHidden) return

    return <Grid key={field?.id} item xs={12}><div className={className} ref={componentRef}>
      <div style={{paddingTop: 0}}>
          <span className='fieldLabel'>
            {field.placeholder} {field.required && <span>*</span>}
          </span>
          <div className="JSONEditor">
            <div>
                <JsonView
                  src={value}
                  theme='a11y'
                  editable={!isDisabled}
                  collapsed={false}
                  enableClipboard={false}
                  collapseStringsAfterLength={6}
                  onEdit={onChange}
                  onDelete={onChange}
                />
                {field.example && <div className='additionalFields' onClick={() => {setHideExample(!hideExample)}}>+ <span className='pseudoLink'>Приклад заповнення</span></div>}
            </div>
            {showExample && !hideExample && <div>
                <p className='instruction'>* щоб додати &#123;&#125; або [], потрібно ввести &#40;&#123;&#125;&#41; або ([])</p>
                <div className="exampleJSON">
                  <JsonView
                    src={field.example}
                    editable={false}
                    collapsed={false}
                    enableClipboard={false}
                    collapseStringsAfterLength={6}
                  />
                </div>
            </div>}

            {!ignoreControlCheck && showErrorText && <div className='fieldError'>
              {showErrorText}
            </div>}
            {!showErrorText && field?.notes &&  <div className='fieldNotes'>
              <p>{field.notes}</p>
            </div>}
          </div>
      </div>
    </div></Grid>
}
